import { render, staticRenderFns } from "./ProfileDropDown.vue?vue&type=template&id=19537cc2&scoped=true"
import script from "./ProfileDropDown.vue?vue&type=script&lang=js"
export * from "./ProfileDropDown.vue?vue&type=script&lang=js"
import style0 from "./ProfileDropDown.vue?vue&type=style&index=0&id=19537cc2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19537cc2",
  null
  
)

export default component.exports